import { render, staticRenderFns } from "./BenefitsBar.vue?vue&type=template&id=741c45f8&scoped=true&"
import script from "./BenefitsBar.vue?vue&type=script&lang=ts&"
export * from "./BenefitsBar.vue?vue&type=script&lang=ts&"
import style0 from "./BenefitsBar.vue?vue&type=style&index=0&id=741c45f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c45f8",
  null
  
)

export default component.exports